import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useUISettings } from 'dashboard/composables/useUISettings';

export const useConversationPins = () => {
  const accountId = useMapGetter('getCurrentAccountId');
  const { uiSettings, updateUISettings } = useUISettings();

  const pinnedConversationIds = computed(() => {
    const pinsByAccount = uiSettings.value.pinned_conversation_ids || {};
    return (pinsByAccount[String(accountId.value)] || []).map(Number);
  });

  const isConversationPinned = conversationId =>
    pinnedConversationIds.value.includes(Number(conversationId));

  const toggleConversationPin = conversationId => {
    const id = Number(conversationId);
    const pinsByAccount = {
      ...(uiSettings.value.pinned_conversation_ids || {}),
    };
    const currentPins = pinnedConversationIds.value;
    pinsByAccount[String(accountId.value)] = currentPins.includes(id)
      ? currentPins.filter(item => item !== id)
      : [...currentPins, id];

    updateUISettings({ pinned_conversation_ids: pinsByAccount });
  };

  return {
    pinnedConversationIds,
    isConversationPinned,
    toggleConversationPin,
  };
};
